import {
  selectCurrentPlayer,
  selectPhase,
  selectRound,
  selectWarPhaseStage
} from "../../../redux/reducers/sharedStateReducer/selectors";

/**
 * Ключ «работы бота» в сетевой игре: единица делегирования (ход бота либо его
 * подтверждения этапа ближнего боя). Сервер выдает делегату этот ключ вместе с
 * DELEGATE_BOT_WORK; клиент-делегат исполняет шаги бота, пока ключ актуального
 * состояния совпадает с делегированным. Формат обязан совпадать на сервере и
 * клиенте — оба используют эту функцию.
 */
export const getBotWorkKey = (state) => {
  const round = selectRound(state);
  const phase = selectPhase(state);
  const warPhaseStage = selectWarPhaseStage(state);
  const currentPlayer = selectCurrentPlayer(state);
  return `${round}|${phase}|${warPhaseStage || ''}|${currentPlayer?.id || ''}`;
};
